import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ITechAssetsDto, ITechAssetsState } from "../shared";

import { TECH_ASSETS_MODULE_NAME } from "./constants";

const initialState: ITechAssetsState = {
  selectedIds: [],
  searchText: "",
};
export const techAssetsSlice = createSlice({
  name: TECH_ASSETS_MODULE_NAME,
  initialState,
  reducers: {
    setSelectedIdsAction(state, action: PayloadAction<string[]>): void {
      state.selectedIds = action.payload;
    },
    toggleId(state, action: PayloadAction<string>): void {
      const id = action.payload;
      if (state.selectedIds.includes(id)) {
        state.selectedIds = state.selectedIds.filter((item) => item !== id);
      } else {
        state.selectedIds = [id, ...state.selectedIds];
      }
    },
    setSearchText(state, action: PayloadAction<string>): void {
      state.searchText = action.payload;
    },
  },
});

export const techAssetsReducer = techAssetsSlice.reducer;
export const { setSelectedIdsAction, toggleId, setSearchText } = techAssetsSlice.actions;

export function safeSortAssetsByName(dtos: ITechAssetsDto[]): void {
  dtos.sort((a, b) => {
    try {
      if (a === null || b === null) {
        return 0; // never happened (insert your breakpoint here)
      }
      const ret = a.name.localeCompare(b.name);
      return ret;
    } catch (_) {
      // console.error(`safeSortAssetsByName: [e, a, b]`, [e, a, b]);
      return 0;
    }
  });
}
